import { render, staticRenderFns } from "./Changewawa.vue?vue&type=template&id=6fc87049&scoped=true&"
import script from "./Changewawa.vue?vue&type=script&lang=js&"
export * from "./Changewawa.vue?vue&type=script&lang=js&"
import style0 from "./Changewawa.vue?vue&type=style&index=0&id=6fc87049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc87049",
  null
  
)

component.options.__file = "Changewawa.vue"
export default component.exports